import React, { useEffect, useMemo, useState } from "react";
import { CacheProvider } from "@emotion/react";
import rtlPlugin from "stylis-plugin-rtl";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import { useMediaQuery } from "react-responsive";
import jwtDecode from "jwt-decode";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {
  Box,
  Button,
  Divider,
  FormControl,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  ButtonGroup,
  IconButton,
  Alert,
  AlertTitle,
} from "@mui/material";
import { getRequest, postRequest } from "../request";
import postReq from "../interface/postRequestinterface";
import getReq from "../interface/getRequestinterface";
import { Add, AddCircle, Close, Edit } from "@mui/icons-material";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loading from "./loading";

const style = {
  formTitle: {
    fontWeight: "bold !important",
  },
  formDescription: {
    color: "#9b9b9b",
  },
  formContainer: {
    padding: "1rem !important",
    border: "3px solid #748DA6",
    borderRadius: "10px",
    backgroundColor: "#f1f7ff59",
    height: "auto",
  },
  gridBox: {
    display: "grid",
    gridTemplateColumns: "40% 40%",
    columnGap: "2%",
    rowGap: "3%",
    justifyContent: "space-around",
    marginTop: "2rem",
  },
  mobileGridBox: {
    display: "grid",
    gridTemplateColumns: "90%",
    // columnGap:'5%',
    rowGap: "3%",
    justifyContent: "center",
    marginTop: "2rem",
  },
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    p: 4,
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    borderRadius: "3px",
    width: "30rem",
  },
  modalMobileStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    p: 4,
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    borderRadius: "3px",
    width: "15rem",
  },
  txtField: {
    width: "100%",
  },
  headerContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
  },
  stateHandler: {
    display: "flex",
    justifyContent: "center",
  },
  stateType: { fontWeight: "bold" },
  title: {
    display: "flex",
    justifyContent: "space-between",
    width: "65rem",
  },
  defineServices: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    width: "100%",
    height: "80vh",
  },
};

interface CharenceLevel {
  id: number;
  title_Level: string;
  maximum_Charense: number;
  minimum_Charense: number;
}
interface CharenceService {
  id: number;
  isActive: boolean;
  level_Id: number;
  price_Service: string;
  title: string;
  type_Id: number;
}
interface CharenceTypes {
  id: number;
  title: string;
}
var token: string | null = "";

function LevelsAndServices() {
  const [decodedToken, setDecodedToken] = useState<any>({});
  const [userLevel, setUserLevel] = useState<string>("");
  const [charenceType, setCharenceType] = useState<string>("");
  const [charenceService, setCharenceService] = useState<string>("");
  const [selectedLevel, setSelectedLevel] = useState(1);
  const [selectedType, setSelectedType] = useState(1);
  const [charenceAmount, setCharenceAmount] = useState<unknown>(0);
  const [isEditLevel, setIsEditLevel] = useState<number>(-1);
  const [isEditType, setIsEditType] = useState<number>(-1);
  const [listOfCharenceLevels, setListOfCharenceLevels] = useState<
    Array<CharenceLevel>
  >([]);
  const [listOfCharenceTypes, setListOfCharenceTypes] = useState<
    Array<CharenceTypes>
  >([]);
  const [listOfCharenceService, setListOfCharenceService] = useState<
    Array<CharenceService>
  >([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [editedService, setEditedService] = useState<number>(-1);
  const [EditLevel, setEditLevel] = useState<string>("");
  const [EditType, setEditType] = useState<string>("");
  const [MaxChrence, setMaxChrence] = useState<number>(0);
  const [MinChrence, setMinChrence] = useState<number>(0);
  ////////////////////////////////////////////////////////////////////////////////////////////////
  const navigate = useNavigate();
  // const [ServiceTitle, setServiceTitle] = useState()
  let decode: any = {};
  token = localStorage.getItem("token");
  useEffect(() => {
    if (token) {
      decode = jwtDecode(token);
      setDecodedToken(decode);
    }
  }, [token]);
  useEffect(() => {
    handleGetListOfServices();
    getListOfCharenceLevels();
    getListOfCharenceTypes();
  }, []);
  const isDesktop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  const isTablet = useMediaQuery({
    query: "((min-width:650px) and (max-width: 900px))",
  });

  const isMobile = useMediaQuery({
    query: "(max-width: 400px)",
  });
  const handleGetListOfServices = async () => {
    const { data, error }: getReq = (await getRequest(
      `${process.env.REACT_APP_BASE_URL}/CharenseServices/List_Charense_Services`
    )) as getReq;
    if (!error) {
      setListOfCharenceService(data);
    }
  };

  const getListOfCharenceLevels = async () => {
    const { data, error }: getReq = (await getRequest(
      `${process.env.REACT_APP_BASE_URL}/CharenseServices/List_Charense_Level`
    )) as getReq;
    if (!error) {
      setListOfCharenceLevels(data);
    }
  };
  const getListOfCharenceTypes = async () => {
    const { data, error }: getReq = (await getRequest(
      `${process.env.REACT_APP_BASE_URL}/CharenseServices/List_Charense_Type`
    )) as getReq;
    if (!error) {
      setListOfCharenceTypes(data);
    }
  };
  const cacheRtl = useMemo(() => {
    return createCache({
      key: "muirtl",
      stylisPlugins: [prefixer, rtlPlugin],
    });
  }, []);

  const handleCreateNewLevel = async () => {
    // const {data,error} :postReq = await postRequest(`${process.env.REACT_APP_BASE_URL}/CharenseServices/Add_Charense_Type`,userLevel) as postReq;
  };
  const handleCreateNewCharenceType = async () => {
    const temp = {
      title: charenceType,
    };
    const { data, error }: postReq = (await postRequest(
      `${process.env.REACT_APP_BASE_URL}/CharenseServices/Add_Charense_Type`,
      temp
    )) as postReq;
    if (!error) {
      toast.success("خدمت مورد نظر با موفقیت ایجاد شد!");
      navigate(0);
    }
  };

  const handleAddnewService = async () => {
    const temp = {
      title: charenceService,
      type_Id: selectedType,
      level_Id: selectedLevel,
      price_Service: charenceAmount,
    };
    const { data, error }: postReq = (await postRequest(
      `${process.env.REACT_APP_BASE_URL}/CharenseServices/Add_Charense_Services`,
      temp
    )) as postReq;
    if (!error) {
      toast.success("سرویس مورد نظر با موفقیت ایجاد گردید!");
      navigate(0);
    }
  };
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const setEditService = (id) => {
    setCharenceService(listOfCharenceService.find((x) => x.id === id)?.title!);
    setCharenceAmount(
      listOfCharenceService.find((x) => x.id === id)?.price_Service!
    );
    setSelectedLevel(
      listOfCharenceTypes.find(
        (x) => x.id === listOfCharenceService.find((y) => y.id === id)?.level_Id
      )?.id!
    );
    setSelectedType(
      listOfCharenceTypes.find(
        (x) => x.id === listOfCharenceService.find((y) => y.id === id)?.type_Id
      )?.id!
    );
    setEditedService(id);
    if (isEditLevel !== -1) {
      setIsEditLevel(-1);
    }
    if (isEditType !== -1) {
      setIsEditType(-1);
    }
  };

  const handleEditService = async () => {
    const temp = {
      id: editedService,
      title: charenceService,
      type_Id: selectedType,
      level_Id: selectedLevel,
      price_Service: charenceAmount,
    };
    const { data, error }: postReq = (await postRequest(
      `${process.env.REACT_APP_BASE_URL}/CharenseServices/Edit_Charense_Services`,
      temp
    )) as postReq;
    if (!error) {
      toast.success("سرویس مورد نظر با موفقیت ویرایش گردید!");
      navigate(0);
    }
  };

  const handleReturnEdit = () => {
    setCharenceService("");
    setCharenceAmount("");
    setSelectedLevel(1);
    setSelectedType(1);
    setEditedService(-1);
  };

  const handleEditCharenceLevel = async () => {
    const temp = {
      id: isEditLevel,
      title_Level: EditLevel,
      maximum_Charense: MaxChrence,
      minimum_Charense: MinChrence,
    };
    const { data, error }: postReq = (await postRequest(
      `${process.env.REACT_APP_BASE_URL}/CharenseServices/Edit_Charense_Level`,
      temp
    )) as postReq;
    if (!error) {
      toast.success("سطح مورد نظر با موفقیت ویرایش گردید!");
      navigate(0);
    }
  };
  const handleSelectForEditLevel = async (id) => {
    setIsEditLevel(id);
    setIsEditType(-1);
    setEditedService(-1);
    const { data, error }: getReq = (await getRequest(
      `${process.env.REACT_APP_BASE_URL}/CharenseServices/Get_Charense_Level?id=${id}`
    )) as getReq;
    if (!error) {
      setMaxChrence(data.maximum_Charense);
      setMinChrence(data.minimum_Charense);
      setEditLevel(data.title_Level);
    }
  };
  const handleSelectForEditType = async (id) => {
    setIsEditType(id);
    setIsEditLevel(-1);
    setEditedService(-1);
    const { data, error }: getReq = (await getRequest(
      `${process.env.REACT_APP_BASE_URL}/CharenseServices/Get_Charense_Type?id=${id}`
    )) as getReq;
    if (!error) {
      setEditType(data.title);
    }
  };
  const handleEditCharenceType = async () => {
    const temp = {
      id: isEditType,
      title: EditType,
    };
    const { data, error }: postReq = (await postRequest(
      `${process.env.REACT_APP_BASE_URL}/CharenseServices/Edit_Charense_Type`,
      temp
    )) as postReq;
    if (!error) {
      toast.success("نوع خدمت مورد نظر با موفقیت ویرایش گردید!");
      navigate(0);
    }
  };
  // const getSelectedLevelCharenceType=async()=>{
  //     const {data,error}:getReq = await getRequest(`${process.env.REACT_APP_BASE_URL}/CharenseServices/List_Charense_Type`) as getReq;
  //     if(!error){
  //         setListOfCharenceTypes(data)
  //     }
  // }

  return (
    <CacheProvider value={cacheRtl}>
      <div className="background">
        {listOfCharenceService.length ? (
          <Box sx={isDesktop ? style.gridBox : style.mobileGridBox}>
            <Box>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Alert severity="success" sx={{ width: "fit-content" }}>
                  <AlertTitle sx={{ fontWeight: "bold", fontSize: "2rem" }}>
                    لیست سرویس ها:
                  </AlertTitle>
                </Alert>
              </Box>
              <Paper sx={{ width: "100%", mb: 2 }}>
                <TableContainer
                  component={Paper}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell className="ratesTh" align="center">
                          سرویس
                        </TableCell>
                        <TableCell className="ratesTh" align="center">
                          نوع سرویس
                        </TableCell>
                        <TableCell className="ratesTh" align="center">
                          سطح
                        </TableCell>
                        <TableCell className="ratesTh" align="center">
                          مقدار کارنس
                        </TableCell>
                        <TableCell className="ratesTh" align="center">
                          ویرایش
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {listOfCharenceService
                        ?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((x, idx) => (
                          <TableRow
                            key={idx}
                            className="ratesTr"
                            sx={{
                              "&:last-child , &:last-child": { border: 0 },
                            }}
                          >
                            <TableCell className="ratesTd" align="center">
                              {x.title}
                            </TableCell>
                            <TableCell className="ratesTd" align="center">
                              {
                                listOfCharenceTypes.find(
                                  (type) => type.id === x.type_Id
                                )?.title
                              }
                            </TableCell>
                            <TableCell className="ratesTd" align="center">
                              {
                                listOfCharenceLevels.find(
                                  (level) => level.id === x.level_Id
                                )?.title_Level
                              }
                            </TableCell>
                            <TableCell className="ratesTd" align="center">
                              {x.price_Service}
                            </TableCell>
                            <TableCell align="center">
                              <IconButton
                                aria-label=""
                                onClick={() => setEditService(x.id)}
                              >
                                <Edit
                                  sx={
                                    editedService === x.id
                                      ? { color: "red" }
                                      : { color: "green" }
                                  }
                                />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  labelRowsPerPage={"تعداد سطر ها"}
                  component="div"
                  count={listOfCharenceService.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </Box>
            <Box sx={style.defineServices}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "70%",
                }}
              >
                {editedService !== -1 ? (
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Alert severity="warning" sx={{ width: "fit-content" }}>
                      <AlertTitle sx={{ fontWeight: "bold", fontSize: "2rem" }}>
                        ویرایش سرویس:
                      </AlertTitle>
                    </Alert>
                  </Box>
                ) : (
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Alert severity="success" sx={{ width: "fit-content" }}>
                      <AlertTitle sx={{ fontWeight: "bold", fontSize: "2rem" }}>
                        ایجاد سرویس جدید:
                      </AlertTitle>
                    </Alert>
                  </Box>
                )}
                <Box>
                  <Typography variant="body1" color="initial">
                    عنوان
                  </Typography>
                  <TextField
                    sx={{ width: "100%" }}
                    value={charenceService}
                    onChange={(e) => setCharenceService(e.target.value)}
                  />
                </Box>
                <Box>
                  <Typography variant="body1" color="initial">
                    سطح
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      value={selectedLevel}
                      label="سطح"
                      onChange={(e) => {
                        setSelectedLevel(e.target.value as number);
                        if (selectedType === -2) {
                          setSelectedType(-1);
                        }
                      }}
                    >
                      {listOfCharenceLevels.map((x) => (
                        <MenuItem
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                          key={x.id}
                          value={x.id}
                        >
                          {x.title_Level}
                          <IconButton
                            aria-label=""
                            onClick={() => handleSelectForEditLevel(x.id)}
                          >
                            <Edit />
                          </IconButton>
                        </MenuItem>
                      ))}
                      {/* {
                                        decodedToken.role === 'Admin'&& editedService===-1?
                                        <MenuItem value={-2}><AddCircle/>افزودن سطح جدید</MenuItem>
                                        :null
                                    } */}
                    </Select>
                  </FormControl>
                </Box>
                <Box>
                  <Typography variant="body1" color="initial">
                    نوع خدمت
                  </Typography>
                  <FormControl fullWidth>
                    <Select
                      value={selectedType}
                      label="نوع خدمت"
                      onChange={(e) => {
                        setSelectedType(e.target.value as number);
                        if (selectedLevel === -2) {
                          setSelectedLevel(-1);
                        }
                      }}
                    >
                      {listOfCharenceTypes.map((x) => (
                        <MenuItem
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                          key={x.id}
                          value={x.id}
                        >
                          {x.title}
                          <IconButton
                            aria-label=""
                            onClick={() => handleSelectForEditType(x.id)}
                          >
                            <Edit />
                          </IconButton>
                        </MenuItem>
                      ))}
                      {decodedToken.role === "Admin" && editedService === -1 ? (
                        <MenuItem value={-2}>
                          <AddCircle />
                          افزودن نوع خدمت جدید
                        </MenuItem>
                      ) : null}
                    </Select>
                  </FormControl>
                </Box>
                <Box>
                  <Typography variant="body1" color="initial">
                    تعداد کارنس
                  </Typography>
                  <TextField
                    label="تعداد کارنس"
                    sx={{ width: "100%" }}
                    value={charenceAmount}
                    onChange={(e) => setCharenceAmount(e.target.value)}
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Box>
                {isEditType === -1 &&
                isEditLevel === -1 &&
                selectedType !== -2 &&
                selectedType !== -2 ? (
                  editedService !== -1 ? (
                    <ButtonGroup
                      variant="contained"
                      sx={{ width: "fit-content" }}
                    >
                      <Button onClick={handleEditService}>ویرایش</Button>
                      <Button
                        onClick={() => setEditedService(-1)}
                        color="secondary"
                      >
                        بازگشت
                      </Button>
                    </ButtonGroup>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleAddnewService}
                    >
                      افزودن
                    </Button>
                  )
                ) : null}
              </Box>
              {selectedLevel === -2 || selectedType === -2 ? (
                <Divider sx={!isDesktop ? { marginTop: "5rem" } : null} />
              ) : null}
              <Box>
                {selectedLevel === -2 &&
                isEditType === -1 &&
                isEditLevel === -1 ? (
                  <Box>
                    <Typography variant="body1" color="initial">
                      افزودن سطح جدید
                    </Typography>
                    <TextField
                      sx={{ width: "100%", margin: "1rem 0rem" }}
                      size="small"
                      label="سطح جدید"
                      value={userLevel}
                      onChange={(e) => setUserLevel(e.target.value)}
                    />
                    <ButtonGroup variant="contained">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleCreateNewLevel}
                      >
                        <Add />
                        ایجاد
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => setSelectedLevel(1)}
                      >
                        <Close />
                        بازگشت
                      </Button>
                    </ButtonGroup>
                  </Box>
                ) : null}
                {selectedType === -2 &&
                isEditType === -1 &&
                isEditLevel === -1 ? (
                  <Box>
                    <Typography variant="body1" color="initial">
                      افزودن نوع خدمت جدید
                    </Typography>
                    <TextField
                      size="small"
                      label="نوع خدمت جدید"
                      sx={{ width: "100%", margin: "1rem 0rem" }}
                      value={charenceType}
                      onChange={(e) => setCharenceType(e.target.value)}
                    />
                    <ButtonGroup variant="contained" aria-label="">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleCreateNewCharenceType}
                      >
                        <Add />
                        ایجاد
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleReturnEdit}
                      >
                        <Close />
                        بازگشت
                      </Button>
                    </ButtonGroup>
                  </Box>
                ) : null}
                {isEditLevel !== -1 ? (
                  <Box sx={{ marginTop: "3rem" }}>
                    <Divider />
                    <Typography variant="h6" color="initial">
                      ویرایش سطح
                    </Typography>
                    <TextField
                      size="small"
                      label="سطح"
                      sx={{ width: "100%", margin: "1rem 0rem" }}
                      value={EditLevel}
                      onChange={(e) => setEditLevel(e.target.value)}
                    />
                    <Typography variant="body1" color="initial">
                      ماکسیمم کارنس
                    </Typography>
                    <TextField
                      label="ماکسیمم کارنس"
                      sx={{ width: "100%" }}
                      size="small"
                      value={MaxChrence}
                      onChange={(e) => setMaxChrence(+e.target.value)}
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <Typography variant="body1" color="initial">
                      مینیمم کارنس
                    </Typography>
                    <TextField
                      label="مینیمم کارنس"
                      sx={{ width: "100%" }}
                      size="small"
                      value={MinChrence}
                      onChange={(e) => setMinChrence(+e.target.value)}
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <ButtonGroup variant="contained" aria-label="">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleEditCharenceLevel}
                      >
                        <Edit />
                        ویرایش
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => setIsEditLevel(-1)}
                      >
                        <Close />
                        بازگشت
                      </Button>
                    </ButtonGroup>
                  </Box>
                ) : null}
                {isEditType !== -1 ? (
                  <Box sx={{ marginTop: "3rem" }}>
                    <Divider />
                    <Typography variant="h6" color="initial">
                      ویرایش نوع خدمت
                    </Typography>
                    <TextField
                      size="small"
                      label="سطح"
                      sx={{ width: "100%", margin: "1rem 0rem" }}
                      value={EditType}
                      onChange={(e) => setEditType(e.target.value)}
                    />

                    <ButtonGroup variant="contained" aria-label="">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleEditCharenceType}
                      >
                        <Edit />
                        ویرایش
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => setIsEditType(-1)}
                      >
                        <Close />
                        بازگشت
                      </Button>
                    </ButtonGroup>
                  </Box>
                ) : null}
              </Box>
            </Box>
          </Box>
        ) : (
          <div
            style={{
              width: "100vw",
              height: "calc( 100vh - 64px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loading type="cylon" color="#000" />
          </div>
        )}
      </div>
    </CacheProvider>
  );
}

export default LevelsAndServices;
